import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import { PodInstallFunction } from "@web-monorepo/shared/podInfra";
import get from "lodash/get";
import { put } from "redux-saga/effects";
import {
  reducer as featureSwitchHandler,
  saga as featureSwitchSaga,
  FEATURE_SWITCHES,
} from "./data/fetchFeatureSwitches";
import { FETCH_SESSION_DONE, fetchSession, fetchSessionSaga, fetchSessionHandler } from "./data/fetchSession";
import env from "shared/util/env";

export { fetchSession, FETCH_SESSION_DONE };

const STATE_KEY = "auth";

export type User = {
  _id: string;
  emailAddress: boolean;
  locale?: string;
};

export type UserConfig = {
  metaData: {
    toolkitWelcomeDismissed: boolean;
  };
  mqttChannels: {
    self: string;
  };
};

type AuthState = {
  user?: User;
  didFetchSession: boolean;
  classes: unknown[] | null;
  entryPoint: string | null;
  error: {
    email: boolean;
    password: boolean;
  };
  resetFailure: boolean;
  resetSuccess: boolean;
  authRequested: boolean;
  authMode: string | null;
  userConfig?: UserConfig;
};

export type AuthSlice = {
  [STATE_KEY]: AuthState;
};

const initialState: AuthState = {
  didFetchSession: false,
  classes: null,
  entryPoint: null,
  error: {
    email: false,
    password: false,
  },
  resetFailure: false,
  resetSuccess: false,
  authRequested: false,
  authMode: null,
  userConfig: undefined,
};

export const userSelector = (state: AuthSlice) => state[STATE_KEY].user;
export const isLoggedInSelector = (state: AuthSlice) => !!state[STATE_KEY].user;
export const selectEmail = (state: AuthSlice) => state[STATE_KEY].user?.emailAddress;
export const selectEntryPointUrl = (state: AuthSlice) => state[STATE_KEY].entryPoint;
export const modalIsOpenSelector = (state: AuthSlice) => !state[STATE_KEY].user && state[STATE_KEY].authRequested;

export const selectFeatureFlag = (state: AuthSlice, flagName: string, valueInDev: boolean) => {
  if (!FEATURE_SWITCHES.includes(flagName)) {
    if (env.isDev === true) {
      throw new Error(`Unable to select ${flagName} -- add it to auth/fetchFeatureSwitches`);
    }
    return false;
  }
  if (env.isDev === true) return valueInDev;
  return get(state, [STATE_KEY, "switches", flagName], false);
};
export const userConfigSelector = (state: AuthSlice) => state[STATE_KEY].userConfig;
export const selectDidFetchSession = (state: AuthSlice) => state[STATE_KEY].didFetchSession;

const finalReducer = combineActionHandlers(initialState, [fetchSessionHandler, featureSwitchHandler]);

function* initAuthSaga() {
  yield put(fetchSession());
}

const installer: PodInstallFunction = (installReducer, installSaga) => {
  installReducer(STATE_KEY, finalReducer);

  installSaga(featureSwitchSaga);
  installSaga(fetchSessionSaga);
  installSaga(initAuthSaga);
};

export default installer;
